import { useEffect, useState } from "react";
import {
  Button,
  Drawer,
  Space,
} from "antd";

const CommonDrawer = ({
  open,
  setOpen,
  title,
  width,
  children,
  isSubmitBtn = { show: false, label: "Submit", loading: false },
  onSubmit,
  isCancelBtn = { show: true, label: "Close" },
  placement = "right"
}) => {
  const [isMobile, setIsMobile] = useState(false);
  const onClose = () => {
    setOpen(false);
  };


  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    // Initialize on mount
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Drawer
        title={<h1 className="sm:text-2xl text-xl font-medium">{title}</h1>}
        width={isMobile ? "100%" : width}
        onClose={onClose}
        open={open}
        styles={{
          body: {
            paddingBottom: 80,
          },
        }}
        closeIcon={false}
        placement={placement}
        classNames={{
          header: "sm:!px-6 px-2"
        }}
        extra={
          <Space>
            {isCancelBtn.show && (
              <Button
                onClick={onClose}
                className="h-10 sm:w-[140px] w-[80px] hover:!border-primary hover:!text-primary"
              >
                {isCancelBtn.label}
              </Button>
            )}
            {isSubmitBtn.show && (
              <Button
                onClick={onSubmit}
                type="primary"
                className="h-10 !bg-primary !text-white w-[140px]"
              >
                {isSubmitBtn.label}
              </Button>
            )}
          </Space>
        }
        className={`[&_.ant-drawer-body]:!p-0`}
      >
        {children}
      </Drawer>
    </>
  );
};

export default CommonDrawer;
